import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import Notifications from "layouts/notifications";
// import RTL from "layouts/rtl";
// import Profile from "layouts/profile";
// import SignIn from "layouts/authentication/sign-in";
// import SignUp from "layouts/authentication/sign-up";

// @mui icons
import Icon from "@mui/material/Icon";
import Products from "./layouts/product";
import Users from "./layouts/user";
import Quotation from "./layouts/quotation";
import Orders from "./layouts/orders";
import ProtectedRoute from "./ProtectedRoute";
import SignIn from "./layouts/authentication/sign-in";
import SignUp from "./layouts/authentication/sign-up";
import Customers from "layouts/customer";
import Permissions from "layouts/permissions";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    sidebar: true,
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    role: "admin",
    component: (
      <ProtectedRoute requiredRole="admin">
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Products",
    key: "products",
    sidebar: true,
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/products",
    role: "all",
    // Nav item shows if the user can view Products OR Combos (both live on this screen).
    modules: ["Product", "Combo"],
    component: (
      <ProtectedRoute requiredRole="all">
        <Products />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Users",
    key: "users",
    sidebar: true,
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/users",
    role: "admin",
    component: (
      <ProtectedRoute requiredRole="admin">
        <Users />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Customers",
    key: "customers",
    sidebar: true,
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/customers",
    role: "all",
    modules: ["Customer"],
    component: (
      <ProtectedRoute requiredRole="all">
        <Customers />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Quotation",
    key: "quotation",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/quotation",
    sidebar: true,
    role: "all",
    modules: ["Order"],
    component: (
      <ProtectedRoute requiredRole="all">
        <Quotation />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Quotation Detail",
    key: "quotation",
    sidebar: false,
    route: "/quotation/:id",
    role: "all",
    modules: ["Order"],
    component: (
      <ProtectedRoute requiredRole="all">
        <Quotation />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Orders",
    key: "orders",
    sidebar: true,
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/orders",
    role: "all",
    modules: ["Order"],
    component: (
      <ProtectedRoute requiredRole="all">
        <Orders />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Permissions",
    key: "permissions",
    sidebar: true,
    icon: <Icon fontSize="small">admin_panel_settings</Icon>,
    route: "/permissions",
    role: "admin",
    component: (
      <ProtectedRoute requiredRole="admin">
        <Permissions />
      </ProtectedRoute>
    ),
  },
  {
    type: "collapse",
    name: "Notifications",
    key: "notifications",
    sidebar: true,
    icon: <Icon fontSize="small">notifications</Icon>,
    route: "/notifications",
    role: "all",
    component: (
      <ProtectedRoute requiredRole="all">
        <Notifications />
      </ProtectedRoute>
    ),
  },
  // {
  //   type: "collapse",
  //   name: "RTL",
  //   key: "rtl",
  //   icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
  //   route: "/rtl",
  //   component: <RTL />,
  // },
  // {
  //   type: "collapse",
  //   name: "Profile",
  //   key: "profile",
  //   icon: <Icon fontSize="small">person</Icon>,
  //   route: "/profile",
  //   component: <Profile />,
  // },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    sidebar: false,
    icon: <Icon fontSize="small">login</Icon>,
    route: "/sign-in",
    role: "user",
    component: <SignIn />,
  },
  {
    type: "collapse",
    name: "Sign Up",
    key: "sign-up",
    sidebar: false,
    icon: <Icon fontSize="small">Register</Icon>,
    route: "/sign-up",
    role: "user",
    component: <SignUp />,
  },
  // {
  //   type: "collapse",
  //   name: "Sign Up",
  //   key: "sign-up",
  //   icon: <Icon fontSize="small">assignment</Icon>,
  //   route: "/authentication/sign-up",
  //   component: <SignUp />,
  // },
];

export default routes;
